import { Vue, Component } from '@/utils';

@Component({
  template: `
  <div id="app">
    <router-view/>
  </div>
  `,
})
export class App extends Vue {
  name = 'app';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app.ts